(function () {
  'use strict';

  angular
    .module('app.paperworks', []);

})();